import { Link } from "react-router";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import type { OutboundPeer } from "@/lib/wecom-outbound-messages";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  senderName?: string;
  peers: OutboundPeer[];
  customersBase: string;
};

/** 群发收件人抽屉：点人进客户时间线 */
export function GroupSendRecipientsDrawer({
  open,
  onOpenChange,
  senderName,
  peers,
  customersBase,
}: Props) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-sm">
        <SheetHeader>
          <SheetTitle>群发 {peers.length} 人</SheetTitle>
          <SheetDescription>
            {senderName ? `跟进人 ${senderName} · ` : ""}
            同一条企微任务会发给下列客户，不是只发给当前窗口。
          </SheetDescription>
        </SheetHeader>
        <ul className="flex flex-col gap-1 px-6 pb-6">
          {peers.length === 0 ? (
            <li className="text-sm text-muted-foreground">暂无收件人</li>
          ) : (
            peers.map((peer) => (
              <li key={peer.id}>
                {peer.contact_id != null ? (
                  <Link
                    to={`${customersBase}/${peer.contact_id}`}
                    className="block rounded-md px-2 py-2 text-sm hover:bg-muted"
                    onClick={() => onOpenChange(false)}
                  >
                    <span className="font-medium text-foreground">{peer.contact_name}</span>
                    <span className="mt-0.5 block text-xs text-muted-foreground">
                      {peer.status === "pending_confirm" ? "待确认" : peer.status}
                    </span>
                  </Link>
                ) : (
                  <div className="rounded-md px-2 py-2 text-sm">
                    <span className="font-medium">{peer.contact_name}</span>
                  </div>
                )}
              </li>
            ))
          )}
        </ul>
      </SheetContent>
    </Sheet>
  );
}
